import React from "react";
import { Typography, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const UtItem = ({ text, onRemove, isHideRemove = false }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        bgcolor: "#C9D6FE",
        px: 1,
        borderRadius: 1,
        display: "inline-flex",
        alignItems: "center",
        py: 1,
        position: "relative",
        m:0.5

      }}
    >
      {text}
      { !isHideRemove && <IconButton size="small" onClick={onRemove}
        sx={{
          ml: 0.5,
          position: "absolute",
          bgcolor: "#fff",
          top: "-10px",
          right: "-5px",
          boxShadow:"0px 4px 4px 0px #00000040",
          p:0.1,
          "&:hover": { backgroundColor: "#fff" },
        }}

      >
        <ClearIcon fontSize="5px" />
      </IconButton>}

    </Typography>
  );
};

export default UtItem;
